import CryptoJS from 'crypto-js';
import { env } from '../environment.template';

const SECRET_KEY: string =
  env.cryptoKey || 'defaultSecretKey';

interface Encrypted {
  encrypt(text: string): string;
  decrypt(
    encryptedData: string | { encryptedBody: string }
  ): string;
}

export const encrypted: Encrypted = {
  encrypt(text: string): string {
    const parsedBase64Key = CryptoJS.enc.Base64.parse(SECRET_KEY);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encryptedData = CryptoJS.AES.encrypt(text, parsedBase64Key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Prepend the IV to the encrypted text
    const ivAndCipherText = iv.concat(encryptedData.ciphertext).toString(CryptoJS.enc.Base64);

    return ivAndCipherText;
  },

  decrypt(
    encryptedInput: string | { encryptedBody: string }
  ): string {
    try {
      const encryptedStr =
        typeof encryptedInput === 'string'
          ? encryptedInput
          : encryptedInput.encryptedBody;

      if (
        !encryptedStr ||
        typeof encryptedStr !== 'string'
      ) {
        throw new Error('Invalid encrypted input');
      }

      const parsedBase64Key = CryptoJS.enc.Base64.parse(SECRET_KEY);
      const decodedText = CryptoJS.enc.Base64.parse(encryptedStr);
      const iv = CryptoJS.lib.WordArray.create(decodedText.words.slice(0, 4));
      const cipherText = CryptoJS.lib.WordArray.create(decodedText.words.slice(4));

      const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: cipherText
      });

      const decryptedData = CryptoJS.AES.decrypt(
        cipherParams,
        parsedBase64Key,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );

      const decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
      
      if (!decryptedText) {
        throw new Error('Decryption returned empty result');
      }

      return decryptedText;
    } catch (err) {
      console.error('Decryption error:', err);
      return typeof encryptedInput === 'string'
        ? encryptedInput
        : JSON.stringify(encryptedInput);
    }
  },
};
